import { useState, useEffect, useCallback } from "react";
import { CookService } from "../../services/CookServices";
import EmptyListPlaceholder from "../Common/EmptyListPlaceholder";
import RatingListForModule from "./RatingListForModule";

const cookService = new CookService();


interface InputProps {
    cookId: number;
}

const CookRatingDetailsTab = ({ cookId}: InputProps) => {
    let [subData, setSubData] = useState<any>(null);
    let [isLoading, setIsLoading] = useState<boolean>();
    const [pageSize, setPageSize] = useState(10);
    const [sort, setSort] = useState<{ field: string; order: "ASC" | "DESC" }>({
      field: "id",
      order: "DESC",
    });

    const refreshData = useCallback(
      (pageNo: number) => {
        setIsLoading(true);
        cookService.fetchAllRatingsForCook(cookId ,pageSize, pageSize * pageNo,{order: sort.order, field: sort.field})
          .then((data) => {
            setSubData(data);
            setIsLoading(false);
          })
          .catch(() => {
            setIsLoading(false);
          });
        },
      [cookId, pageSize, sort]
    );

    useEffect(() => {
      refreshData(0);
    }, [refreshData]);

    const handleSortChange = (field: string, order: "ASC" | "DESC") => {
      setSort({ field, order });
    };

    // Remount the list when the sort changes so pagination resets to page 0
    const listKey = `${sort.field}-${sort.order}`;

    return (
      <div>
      {subData &&
        subData?.data &&
        Array.isArray(subData?.data) &&
        (subData?.data?.length > 0 ? (
          <RatingListForModule
            key={listKey}
            isLoading={isLoading}
            count={subData?.count}
            data={subData?.data}
            refreshData={refreshData}
            setPageSize={setPageSize}
            pageSize={pageSize}
            sort={sort}
            onSortChange={handleSortChange}
          />
        ) : (
          <EmptyListPlaceholder message = {'No Ratings found for this cook'}/>
        ))}
    </div>
    );
}

export default CookRatingDetailsTab
